"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageInput = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
require("emoji-mart/css/emoji-mart.css");
var _emojiMart2 = require("emoji-mart");
var _propTypes = require("prop-types");
var _InteractiveChatMessages = require("../InteractiveChatMessages.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TEXTAREA_MAX_HEIGHT = 90;
var TEXTAREA_MIN_HEIGHT = 40;
var MessageInput = exports.MessageInput = function MessageInput(_ref) {
  var onInput = _ref.onInput,
    inputMarginBottom = _ref.inputMarginBottom,
    placeholder = _ref.placeholder,
    allowAnon = _ref.allowAnon;
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    showEmoji = _useState4[0],
    setShowEmoji = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isAnon = _useState6[0],
    setAnon = _useState6[1];
  var textRef = (0, _react.useRef)();
  var Icon = function Icon(_ref2) {
    var icon = _ref2.icon,
      screenReaderText = _ref2.screenReaderText;
    return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.StyledIcon, {
      color: "#8D91AF",
      icon: icon
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "visually-hidden"
    }, screenReaderText));
  };
  function updateHeight() {
    if (this.scrollHeight < TEXTAREA_MAX_HEIGHT) {
      this.style.height = 'auto';
      this.style.height = "".concat(this.scrollHeight > TEXTAREA_MIN_HEIGHT ? this.scrollHeight : TEXTAREA_MIN_HEIGHT, "px");
    }
  }
  var closeEmojiPicker = function closeEmojiPicker(event) {
    if (event.key === 'Escape') {
      setShowEmoji(false);
    }
  };
  var restoreHeight = function restoreHeight() {
    var textarea = document.querySelector('#tarea-input');
    textarea.style.height = 'auto';
    textarea.style.height = TEXTAREA_MIN_HEIGHT;
  };
  (0, _react.useEffect)(function () {
    var textarea = document.querySelector('#tarea-input');
    textarea.addEventListener('input', updateHeight, false);

    // closes the emoji picker when user press escape
    document.addEventListener('keydown', closeEmojiPicker, false);
    return function () {
      textarea.removeEventListener('input', updateHeight, false);
      document.removeEventListener('keydown', closeEmojiPicker, false);
    };
  }, []);
  var onKeyDown = function onKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      var trimmed = text.trim();
      if (trimmed) {
        onInput(trimmed, isAnon);
        setText('');
        restoreHeight();
      }
      return;
    }
    if (text.length > 131 && e.keyCode !== 8) {
      e.preventDefault();
      return;
    }
  };
  var onEmojiSelect = function onEmojiSelect(emoji) {
    setText("".concat(text).concat(emoji["native"], " "));
    setShowEmoji(false);
    textRef.current.focus(); // focus the input field after closing the emoji picker
  };

  var onTextChange = function onTextChange(e) {
    setText(e.target.value);
  };
  return /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.MessageInputWrapper, {
    $inputMarginBottom: inputMarginBottom
  }, /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.RelativePosition, null, /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.InnerContainer, null, /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.StyledTextarea, {
    rows: 1,
    id: "tarea-input",
    style: {
      resize: 'none'
    },
    placeholder: placeholder,
    value: text,
    onChange: onTextChange,
    onKeyDown: onKeyDown,
    "data-testid": "tarea-input",
    ref: textRef,
    "aria-label": "Send a message"
  }), /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.StyledIconsWrapper, {
    className: "icons"
  }, /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.StyledIconButton, {
    "data-testid": "show-emoji",
    onClick: function onClick() {
      return setShowEmoji(!showEmoji);
    }
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    icon: _freeSolidSvgIcons.faSmile,
    screenReaderText: "Add emoji"
  })), /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.StyledPickerContainer, null, showEmoji && /*#__PURE__*/_react["default"].createElement(_emojiMart2.Picker, {
    theme: "dark",
    onSelect: onEmojiSelect,
    style: {
      position: 'absolute',
      bottom: '63px',
      left: '0px',
      width: '100%'
    },
    showPreview: false,
    showSkinTones: false
  })))), /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.Footer, {
    className: "d-flex w-100 p-0"
  }, /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.StyledInputAnonWrapper, {
    className: "m-0 d-".concat(allowAnon ? 'inline-block' : 'none'),
    "data-testid": "anon-widget"
  }, /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.StyledCheckbox, {
    className: "me-1 pt-0",
    onClick: function onClick(isChecked) {
      return setAnon(isChecked);
    },
    dataTestId: "anon-checkbox"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "d-inline-block"
  }, "Anonymous")), /*#__PURE__*/_react["default"].createElement(_InteractiveChatMessages.SendInstruction, null, "Return to send"))));
};
MessageInput.defaultProps = {
  inputMarginBottom: '0'
};
MessageInput.propTypes = {
  onInput: _propTypes.func.isRequired,
  inputMarginBottom: _propTypes.string
};